import { TextField } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import classNames from "classnames";
import React from 'react';
import { EmailBody } from '../../../types/files';

const useStyles = makeStyles(() => ({
    textField: {
        width: '100%',
        "& .MuiOutlinedInput-root": {
            width: '100%',
            padding: 'unset',
            "& > textarea": {
                fontFamily: 'Inter',
                fontSize: '1rem',
                padding: 'unset',
                paddingRight: 8,
            },
        },
    },
}));

const EmailSummaryAnswer: React.FC<{
    content?: EmailBody & {summary : string},
 }> = ({ content }) => {
    const classes = useStyles();

    return (<>
        <TextField variant="outlined"
            className={classNames('no-border', classes.textField)}
            inputProps={{ style: { width: '100%' }, className: 'no-fade' }}
            defaultValue={content?.summary || 'No email summary'}
            maxRows={7}
            multiline disabled
        />
    </>);
}

export default EmailSummaryAnswer;
